// extracted by mini-css-extract-plugin
export var defaultRatioClass = "video-post-preview-module--default-ratio-class--h93Jf";
export var header = "video-post-preview-module--header--zt0kd";
export var image = "video-post-preview-module--image--euPd1";
export var imageWrapper = "video-post-preview-module--imageWrapper--hzjy1";
export var playButton = "video-post-preview-module--playButton--QjHEh";
export var videoButton = "video-post-preview-module--videoButton--KXbZI";